module.exports = __webpack_public_path__ + "static/armanite-54249fc1e819a927a0f5b843e2253a38.png";